<template>
    <div id="main-content" class="bus-history">
        <el-col :offset="1" :span="22">
            <PageTitle :title="title" :backLink="backLink"></PageTitle>
            <el-tabs v-model="activeName">
                <el-tab-pane :label="$t('common.pickup_route')" name="pickup-route">
                    <BusHistoryPickupRoute :student-list="studentList" :bus-list="busList"></BusHistoryPickupRoute>
                </el-tab-pane>
                <el-tab-pane :label="$t('common.drop_route')" name="drop-route">
                    <BusHistoryDropRoute :student-list="studentList" :bus-list="busList"></BusHistoryDropRoute>
                </el-tab-pane>
            </el-tabs>
        </el-col>
    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'
  import BusHistoryPickupRoute from "@/components/Bus/BusHistoryPickupRoute"
  import BusHistoryDropRoute from "@/components/Bus/BusHistoryDropRoute"

  export default {
    name: 'BusHistory',
    components: {
      BusHistoryPickupRoute,
      BusHistoryDropRoute,
      PageTitle
    },
    data: function () {
      return {
        backLink: ``,
        title: 'common.bus_history',
        activeName: 'pickup-route',
        studentList: []
      }
    },
    created: function () {
      this.$store.dispatch('bus/retrieveBusList', {})
      this.$store.dispatch('student/retrieveMasterStudentList', {
        successCallback: (response) => {
          this.studentList = [].concat(response.data.student_list)
        },
        fields: 'id,fullname,romaji,class_id'
      })
    },
    methods: {

    },
    mounted: function () {

    },
    computed: {
      ...mapState('bus', ['busList'])
    }
  }
</script>

<style lang="scss">
    .bus-history {
        table {
            width: 100%;

            td, th {
                padding: 10px;
            }
        }

        .history-note {
            &__action {
                text-align: center;
                margin-top: 10px;

                &__buttons {
                    overflow: hidden;
                    display: inline-block;

                    span {
                        display: block;
                        float: left;
                        height: 40px;
                        cursor: pointer;
                        width: 40px;
                        border-radius: 40px;
                        text-align: center;
                        margin-right: 10px;

                        i {
                            font-size: 20px;
                            line-height: 40px;
                            color: #fff;
                        }

                        &.edit-button, &.save-button {
                            background: #3a8ee6;
                        }

                        &.cancel-button {
                            background: #dd6161;
                        }
                    }

                    span:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
    }
</style>
